import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import SectionHero from '../Helpers/SectionHero';
import ServiceCard from '../Helpers/ServiceCard';
import { useLanguage } from '../../i18n/LanguageContext';

const WHATSAPP = 'https://wa.me/524423424429?text=Hola,%20me%20gustaría%20cotizar%20equipos%20/%20consumibles.';

// Metadata (íconos) por categoría; el texto viene de t('equipos.categorias') por índice.
const categoryIcons = ['fa-laptop', 'fa-video', 'fa-network-wired', 'fa-print', 'fa-keyboard'];
const benefitIcons = ['fa-user-tie', 'fa-certificate', 'fa-file-invoice-dollar', 'fa-truck'];

const Equipos = () => {
    const { t } = useLanguage();
    const categorias = t('equipos.categorias').map((c, i) => ({ ...c, icon: categoryIcons[i] }));
    const benefits = t('equipos.benefits').map((b, i) => ({ ...b, icon: benefitIcons[i] }));

    return (
        <>
            {/* Hero */}
            <SectionHero badge={t('equipos.badge')} title={t('equipos.title')}>
                <p className="text-blue-100 text-lg md:text-xl">
                    {t('equipos.subtitle')}
                </p>
                <a href={WHATSAPP} target="_blank" rel="noreferrer" className="btn btn-accent mt-8">
                    <i className="fab fa-whatsapp"></i>
                    {t('equipos.ctaButton')}
                </a>
            </SectionHero>

            {/* Catálogo de categorías — fondo claro, lenguaje visual alineado al inicio */}
            <section
                className="relative overflow-hidden py-24"
                style={{ background: 'linear-gradient(180deg, #f8fafc 0%, #eef3f8 100%)' }}
            >
                <div
                    className="dot-grid pointer-events-none absolute top-10 right-8 w-44 h-32 opacity-60 hidden md:block"
                    style={{ maskImage: 'linear-gradient(225deg, #000, transparent 75%)', WebkitMaskImage: 'linear-gradient(225deg, #000, transparent 75%)' }}
                ></div>
                <div className="contain relative z-10">
                    <div className="text-center max-w-2xl mx-auto mb-16" data-aos="fade-up">
                        <h2 className="text-salient-primary font-bold text-4xl mb-4">{t('equipos.sectionTitle')}</h2>
                        <span className="title-underline mx-auto"></span>
                        <p className="text-gray-600 mt-4">{t('equipos.sectionSubtitle')}</p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
                        {categorias.map((cat, index) => (
                            <ServiceCard
                                key={index}
                                index={index}
                                icon={cat.icon}
                                subtitle={cat.subtitle}
                                title={cat.title}
                                items={cat.items}
                                delay={(index % 3) * 100}
                            />
                        ))}
                    </div>
                </div>
            </section>

            {/* ¿Por qué comprar con nosotros? */}
            <section className="bg-white py-20">
                <div className="contain">
                    <div className="text-center max-w-2xl mx-auto mb-14" data-aos="fade-up">
                        <h2 className="text-salient-primary font-bold text-3xl md:text-4xl mb-4">{t('equipos.benefitsTitle')}</h2>
                        <span className="title-underline mx-auto"></span>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                        {benefits.map((b, index) => (
                            <div key={index} className="text-center flex flex-col items-center" data-aos="fade-up" data-aos-delay={(index % 4) * 100}>
                                <div className="w-16 h-16 mb-5 flex items-center justify-center rounded-full bg-gradient-to-br from-salient-primary to-salient-primary-hover text-white text-2xl ring-4 ring-salient-green/15 border border-salient-green/30">
                                    <i className={`fas ${b.icon}`}></i>
                                </div>
                                <h3 className="font-heading text-lg font-bold text-salient-primary mb-2">{b.title}</h3>
                                <p className="text-slate-600 text-sm leading-relaxed">{b.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA final (WhatsApp) */}
            <section className="bg-navy-gradient relative overflow-hidden py-20 text-center">
                <div className="absolute -top-24 -right-24 w-80 h-80 bg-salient-green/10 rounded-full blur-3xl"></div>
                <div className="contain relative z-10">
                    <h2 className="text-white font-bold text-3xl md:text-4xl mb-4">{t('equipos.ctaTitle')}</h2>
                    <span className="title-underline mx-auto mb-6"></span>
                    <p className="text-slate-300 text-lg max-w-2xl mx-auto mb-8">{t('equipos.ctaText')}</p>
                    <a href={WHATSAPP} target="_blank" rel="noreferrer" className="btn btn-accent">
                        <i className="fab fa-whatsapp"></i>
                        {t('equipos.ctaButton')}
                    </a>
                </div>
            </section>
        </>
    );
};

export default Equipos;
